module.exports = __webpack_public_path__ + "img/harness-text-no-logo.496f578a.svg";